import React, { Component } from 'react'
import { connect } from 'react-redux'
import  api  from "../Api/AxiosConfig";

import {
  WarningOutlined
} from '@ant-design/icons';

export class NetworkInformation extends Component {


  constructor(props) {
    super(props);
    this.state = {
      status: true,
      interval: 600000,
    }
    this.pollingId= false;
  }



  setPolling = async () => {
    try {
      const res = await api.get("/User/CheckConnectivity");

    
      if (res.status === 200) {
        this.setState({
          status: true,
        })
      }
    } catch (e) {
      this.setState({
        status: false,
      })
    }
  }


  componentWillUnmount() {
    if (this.pollingId) {
      this.stopPolling();
    }
  }


  startPolling() {
   
    this.pollingId = setInterval(() => {
      this.setPolling()
    }, this.state.interval);
  }


  componentDidMount() {
    this.startPolling();
  }

  stopPolling() {
    clearInterval(this.pollingId);
  }

  render() {


    
    return (
      <>
        {!this.state.status &&
       
          <div
          className='container-fluid position-fixed text-white bg-danger'
          style={{ bottom: 0 }}>
          <div className='row'>
              <div className='col-md-12 pt-1'>
                  <h6> <WarningOutlined /> Please check internet connection.</h6>
              </div>
          </div>
      </div>
        }
      </>
    )
  }
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(NetworkInformation)


